import { render, staticRenderFns } from "./RelatedProduct.vue?vue&type=template&id=d3e4bc38&scoped=true&"
import script from "./RelatedProduct.vue?vue&type=script&lang=js&"
export * from "./RelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProduct.vue?vue&type=style&index=0&id=d3e4bc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e4bc38",
  null
  
)

export default component.exports